<template>
  <div class="body">
    <div class="_title">
      <p class="_title_info">单位认证信息</p>
    </div>
    <div style="margin: auto; text-align: center">
      <span style="color: #2860ec">*</span>
      <!-- 单位 分公司才会触发SCR识别 -->
      <span style="font-size: 14px; margin-right: 10px">单位性质:</span>
      <el-radio-group v-model="CommonForm.dwxz" @change="itemChange">
        <el-radio
          v-for="item in dwxzList"
          :key="item.value"
          :disabled="step == 5"
          :label="item.value"
        >{{ item.label }}</el-radio>
      </el-radio-group>
    </div>
    <div class="_yyzzPic">
      <el-upload
        :disabled="step == 5"
        class="upload-demo"
        :action="returnSaveFile"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :before-upload="beforeUpload"
        :on-success="onSuccess"
        :show-file-list="false"
        :on-error="onError"
        :on-progress="onProgress"
        :on-exceed="handleExceed"
        :data="imgInfomation"
        :headers="token"
      >
        <el-image
          v-loading="yyzzImg.loading"
          :src="yyzzImg.img"
          draggable="false"
          style="width: 198px; height: 229px"
          alt=""
        />
      </el-upload>
      <div
        v-show="yyzzImg.closeBox"
        v-preventReClick
        class="deleteUpload"
        @click="removeCurImg(item.name)"
      >
        <i class="el-icon-circle-close" />
      </div>
    </div>
    <p style="text-align: center">{{ dwxzWorld }}</p>
    <div class="qiyeForm">
      <div class="_jbxxInfo">
        <div class="_jbxxTitle">单位基本信息</div>
        <div class="_jbxxBd">
          <el-form
            ref="CommonForm1"
            :model="CommonForm"
            :rules="rules"
            label-position="left"
            class="_jbxxForm"
            label-width="140px"
          >
            <el-form-item v-if="labelFlag.dwmc" :label="dwmcName" prop="dwmc">
              <el-input
                v-model="CommonForm.dwmc"
                placeholder="请输入单位名称"
                maxlength="200"
                :disabled="step == 5"
              />
            </el-form-item>
            <el-form-item
              v-if="labelFlag.shtyxydm"
              :label="shtyxydmName"
              prop="shtyxydm"
            >
              <el-input
                v-model="CommonForm.shtyxydm"
                placeholder="请输入"
                maxlength="100"
                :disabled="step == 5"
              />
              <el-tooltip
                class="item"
                effect="dark"
                content="若是分公司,请在原社会统一信用代码后添加'-x',如-1"
                placement="right"
              >
                <i
                  style="position: absolute; top: 10px; margin-left: 5px"
                  class="el-icon-question"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="labelFlag.dwlx" :label="dwlxName" prop="dwlx">
              <el-select
                v-model="CommonForm.dwlx"
                :disabled="step == 5"
                placeholder="请选择单位类型"
              >
                <el-option
                  v-for="(item, i) in dwlxList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="labelFlag.YyqxDate"
              :label="YyqxDateName"
              prop="yyqxKs"
            >
              <el-date-picker
                v-model="CommonForm.yyqxKs"
                :disabled="step == 5"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 46%"
                placeholder="选择日期"
                :picker-options="this.startTime(CommonForm.yyqxJs)"
              />
              至
              <el-date-picker
                v-model="CommonForm.yyqxJs"
                :disabled="step == 5"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 46%"
                placeholder="选择日期"
                :picker-options="this.endTime(CommonForm.yyqxKs)"
              />
            </el-form-item>
            <el-form-item v-if="labelFlag.clrq" :label="clrqName" prop="clrq">
              <el-date-picker
                v-model="CommonForm.clrq"
                :disabled="step == 5"
                style="width: 297px"
                value-format="yyyy-MM-dd"
                type="date"
                :picker-options="this.startTime()"
                placeholder="请选择成立日期"
              />
            </el-form-item>
            <el-form-item
              v-if="labelFlag.zczb"
              class="zczbItem"
              :label="zczbName"
              prop="zczb"
              width="120px"
            >
              <el-input
                v-model="CommonForm.zczb"
                :disabled="step == 5"
                placeholder="请输入注册资本"
              >
                <el-select
                  slot="append"
                  v-model="CommonForm.zczbDw"
                  :disabled="step == 5"
                  placeholder="请选择货币"
                  @change="zczbChange"
                >
                  <el-option
                    v-for="(item, i) in djdwList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item v-if="labelFlag.frmc" :label="frmcName" prop="frmc">
              <el-input
                v-model="CommonForm.frmc"
                :disabled="step == 5"
                placeholder="请输入法定代表人/经营者"
              />
            </el-form-item>
            <el-form-item label="发证机关:" prop="fzjg">
              <el-input
                v-model="CommonForm.fzjg"
                :disabled="step == 5"
                maxlength="255"
                placeholder="请输入发证机关"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="_qtxxInfo">
        <div class="_qtxxTitle">单位其他信息</div>
        <div class="_qtxxBd">
          <el-form
            ref="CommonForm2"
            :rules="rules"
            label-position="left"
            class="_qtxxForm"
            label-width="140px"
            :model="CommonForm"
          >
            <el-form-item v-if="labelFlag.dwzj" :label="dwzjName" prop="dwzj">
              <el-input
                v-model="CommonForm.dwzj"
                :disabled="step == 5"
                maxlength="50"
                placeholder="请输入座机或手机号"
              />
            </el-form-item>
            <el-form-item
              v-if="labelFlag.cyrysl"
              :label="cyryslName"
              prop="cyrysl"
            >
              <el-input
                v-model="CommonForm.cyrysl"
                :disabled="step == 5"
                maxlength="9"
                placeholder="请输入从业人员数量"
              />
            </el-form-item>
            <el-form-item
              v-if="labelFlag.zhxs"
              label="组成形式"
              prop="zhxs"
              style="width: 100%"
            >
              <el-input
                v-model="CommonForm.zhxs"
                style="width: 100%"
                :disabled="step == 5"
                placeholder="请输入组成形式"
              />
            </el-form-item>
            <el-form-item
              v-if="labelFlag.gsgajg"
              :label="gsgajgName"
              prop="gsgajg"
            >
              <el-cascader
                key="bbigdd"
                v-model="gsgajg"
                :disabled="step == 5"
                placeholder="请选择"
                :props="props"
                @change="gsgajgChange"
              />
            </el-form-item>
            <!-- :options="cascaderOptions" -->
            <el-form-item
              v-if="labelFlag.sjjyd"
              class="jydItem"
              :label="sjjydName"
              prop="sjjyd"
            >
              <el-input
                v-model="CommonForm.sjjyd"
                :disabled="step == 5"
                placeholder="请输入实际经营地"
              />
            </el-form-item>
            <el-form-item
              v-if="labelFlag.dwzs"
              class="jydItem"
              :label="dwzsName"
              prop="dwzs"
            >
              <el-input
                v-model="CommonForm.dwzs"
                :disabled="step == 5"
                placeholder="请输入单位住所"
              />
            </el-form-item>
            <el-form-item v-if="labelFlag.jyfw" :label="jyfwName" prop="jyfw">
              <el-input
                v-model="CommonForm.jyfw"
                :disabled="step == 5"
                type="textarea"
                :rows="3"
                resize="none"
                placeholder="请输入经营范围"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="step != 5" class="_buttonList">
        <el-button v-preventReClick @click="upstep">上一步</el-button>
        <el-button
          v-preventReClick
          style="background-color: #4170ff; color: white"
          type="primary"
          @click="nextstep"
        >下一步</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getXzqTree,
  getXzqTreeS,
  saveQyrzxx
} from '@/assets/js/step2.js'
import {
  getkv,
  getToken,
  returnSaveFile,
  returnShowPic
} from '@/assets/js/common.js'
import { startTime, endTime, lengthValidate } from '@/assets/js/validate.js'

export default {
  props: {
    step: Number
  },
  data() {
    const numberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入'))
      } else if (
        /^[1-9]\d{0,12}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(value) == false
      ) {
        callback(new Error('整数位最大长度13位,保留2位小数'))
      }
      if (!this.CommonForm.zczbDw) {
        callback(new Error('请选择货币'))
      }
      callback()
    }
    const shtyxydmValidator = (rule, value, callback) => {
      if (this.CommonForm.dwxz == '1') {
        if (!value) {
          callback(new Error('统一社会信用代码不能为空'))
        } else {
          var patrn =
            /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
          // 正则校验
          if (patrn.test(value) == false) {
            callback(new Error('统一社会信用代码格式错误'))
          } else {
            // 校验前两位
            var pre_two = value.substring(0, 2)
            var pre_two_arr = [
              '11',
              '12',
              '13',
              '19',
              '21',
              '29',
              '31',
              '32',
              '33',
              '34',
              '35',
              '39',
              '41',
              '49',
              '51',
              '52',
              '53',
              '59',
              '61',
              '62',
              '69',
              '71',
              '72',
              '79',
              '81',
              '89',
              '91',
              '92',
              '93',
              'A1',
              'A9',
              'N1',
              'N2',
              'N3',
              'N9',
              'Y1'
            ]
            if (pre_two_arr.indexOf(pre_two) == -1) {
              callback(new Error('统一社会信用代码格式错误'))
            }
          }
        }
      } else {
        /* if (!value) {
          callback(new Error("统一社会信用代码不能为空"));
        } */
        lengthValidate(rule, value, callback, 'bt', 100)
      }
      callback()
    }
    const peopleValidator = (rule, value, callback) => {
      if (/^\d{1,9}$/.test(value) == false) {
        callback(new Error('支持最长9位正整数'))
      }
      callback()
    }
    const phoneValidator = (rule, value, callback) => {
      const reg1 = /^(0\d{2,3}-\d{7,8})$/ // 座机
      const reg2 = /^1[3456789]\d{9}$/
      if (!reg1.test(value) && !reg2.test(value)) {
        callback(new Error('请输入正确的电话或手机号格式'))
      }
      callback()
    }
    const jgjiaoyan = (rule, value, callback) => {
      if (this.gsgajg.length == 0) {
        return callback(new Error('请选择行政区划'))
      } else {
        this.gsgajg.forEach((element) => {
          if (element == undefined) {
            return callback(new Error('请选择行政区划'))
          }
        })
        callback()
      }
    }
    const dateValidator = (rule, value, callback) => {
      if (!this.CommonForm.yyqxKs) {
        callback(new Error('请输入起始时间'))
      }
      if (!this.CommonForm.yyqxJs) {
        callback(new Error('请输入结束时间'))
      }
      if (this.CommonForm.yyqxJs < this.CommonForm.yyqxKs) {
        callback(new Error('结束时间不可早于起始时间'))
      }
      callback()
    }
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '长期有效',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 200)
        }
      },
      dwxzWorld: '营业执照',
      dwmcName: '单位名称:',
      shtyxydmName: '统一社会信用代码:',
      dwlxName: '单位类型:',
      dwzsName: '单位住所:', //
      frmcName: '法人/经营者:', //
      zczbName: '注册资本:', //
      clrqName: '成立日期:', //
      jyfwName: '经营范围:', //
      dwzjName: '单位座机:', // 单位座机
      sjjydName: '实际经营地:', //
      cyryslName: '从业人员数量:', //
      YyqxDateName: '营业期限:', //
      gsgajgName: '行政区划:',
      /*  */
      dwxzList: [],
      /* 字典项相关数组 */
      dwlxList: [],
      djdwList: [],
      cascaderOptions: [],
      gsgajg: '',
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '',
      returnShowPic: '',
      imgInfomation: {
        sbzjlx: 'yyzzSb'
      },
      yyzzImg: {
        name: '营业执照',
        img: require('../../assets/img/yyzz.png'),
        havePic: false,
        closeBox: false,
        loading: false
      },
      urlType: this.$store.state.RWLCType,
      labelName: {},
      labelFlag: {
        dwmc: true, // 单位名称
        shtyxydm: true, // 社会统一信用代码
        dwxz: '1', // 单位性质
        dwlx: true, // 单位类型
        dwzs: true, // 单位住所
        frmc: true, // 法人/经营者名称
        zczb: true, // 注册资本
        clrq: true, // 成立日期
        jyfw: true, // 经营范围
        dwzj: true, // 单位座机
        sjjyd: true, // 实际经营地
        cyrysl: true, // 从业人员数量
        YyqxDate: true, // 营业执照路径
        gsgajg: true
      },
      /* 公共属性 */
      CommonForm: {
        id: '', // 主键
        dwmc: '', // 单位名称
        shtyxydm: '', // 社会统一信用代码
        dwxz: '1', // 单位性质
        dwlx: '', // 单位类型
        dwzs: '', // 单位住所
        frmc: '', // 法人/经营者名称
        zczb: '', // 注册资本
        clrq: '', // 成立日期
        yyqxKs: '', // 营业期限开始
        yyqxJs: '', // 营业期限结束
        jyfw: '', // 经营范围
        dwzj: '', // 单位座机
        dwsj: '', // 单位手机
        sjjyd: '', // 实际经营地
        cyrysl: '', // 从业人员数量
        province: '', // 省
        city: '', // 市
        county: '', // 区
        zczbDw: '', // 货币
        yyzzUrl: '', // 营业执照路径
        YyqxDate: [], // 营业执照路径
        fzjg: '',
        zczbDwLabel: ''
        /*  */
      },
      rules: {
        dwmc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        dwxz: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        shtyxydm: [
          {
            required: true,
            validator: shtyxydmValidator,
            trigger: ['blur', 'change']
          }
        ],
        dwlx: [
          {
            required: true,
            message: '单位类型不能为空',
            trigger: ['blur', 'change']
          }
        ],
        yyqxKs: [{ required: true, validator: dateValidator, trigger: 'blur' }],
        clrq: [
          { required: true, message: '成立日期不能为空', trigger: 'blur' }
        ],
        zczb: [
          {
            required: true,
            validator: numberValidator,
            trigger: ['blur', 'change']
          }
        ],
        frmc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        dwzj: [
          {
            required: true,
            validator: phoneValidator,
            trigger: ['blur', 'change']
          }
        ],
        cyrysl: [
          {
            required: true,
            validator: peopleValidator,
            trigger: ['blur', 'change']
          }
        ],
        gsgajg: [{ required: true, validator: jgjiaoyan, trigger: 'change' }],
        sjjyd: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 580)
            },
            trigger: ['blur', 'change']
          }
        ],
        jyfw: [
          {
            required: true,
            message: '经营范围不能为空',
            trigger: ['blur', 'change']
          },
          {
            min: 1,
            max: 3000,
            message: '内容不能超过3000个字符',
            trigger: ['blur', 'change']
          }
        ],
        dwzs: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 600)
            },
            trigger: ['blur', 'change']
          }
        ],
        fzjg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        zhxs: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100)
            },
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    /* 单位性质 */
    getkv('yzd_dwxz').then((e) => {
      this.dwxzList = e.data.data
    })
    /* 单位类型 */
    getkv('yzd_dwlx').then((e) => {
      this.dwlxList = e.data.data
    })
    /* 单价单位 */
    getkv('yzd_xkzdjdw').then((e) => {
      this.djdwList = e.data.data
    })
    // selQyrzxx(this.urlType).then((e) => {
    //   const data = e.data.data;
    //   if (data.id !== null) {
    //     this.CommonForm = data;
    //     this.dwxzList.forEach((element) => {
    //       if (data.dwxz === element.value) {
    //         this.panduan(element.label);
    //       }
    //     });
    //   }
    //   /* 时间选择器赋值回显 */
    //   if (data.yyqxKs != "" && data.yyqxKs != null) {
    //     this.CommonForm.YyqxDate = [data.yyqxKs, data.yyqxJs];
    //   }
    //   /* 营业执照上传 */
    //   if (data.yyzzUrl != "" && data.yyzzUrl != null) {
    //     this.yyzzImg.img = this.returnShowPic + data.yyzzUrl;
    //     this.yyzzImg.havePic = true;
    //   }
    //   this.gsgajg = [data.province, data.city, data.county];
    // });
  },
  mounted() {},
  methods: {
    lengthValidate,
    startTime,
    endTime,
    itemChange(val) {
      this.dwxzList.forEach((element) => {
        if (val === element.value) {
          switch (element.label) {
            case '企业':
              this.dwxzWorld = '营业执照'
              break
            case '分公司':
              this.dwxzWorld = '营业执照'
              break
            case '社会团体':
              this.dwxzWorld = '社会团体法人/经营者登记证书'
              break
            case '部队单位':
              this.dwxzWorld = '登记证书/成立批准文件'
              break
            case '事业单位':
              this.dwxzWorld = '事业单位法人/经营者证书'
              break
            case '党政机关':
              this.dwxzWorld = '行政执法主体资格证'
              break
            default:
              this.dwxzWorld = '营业执照'
              break
          }
          this.panduan(element.label)
        }
      })
    },
    /* 判断显示哪些字段 用哪个表单*/
    panduan(value) {
      switch (value) {
        case '企业':
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '分公司':
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业执照路径
            gsgajg: true
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '社会团体':
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            shtyxydm: true, // 社会统一信用代码
            sjjyd: true, // 实际经营地
            zczb: true, // 注册资本
            dwzj: true, // 单位座机
            gsgajg: true,
            YyqxDate: true, // 营业执照路径
            clrq: true // 成立日期
          }
          this.dwmcName = '单位名称:'
          this.jyfwName = '业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.sjjydName = '活动地域:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.zczbName = '注册资本:' //
          this.gsgajgName = '业务主管单位:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:'
          break
        case '事业单位':
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            dwzj: true, // 单位座机
            shtyxydm: true, // 社会统一信用代码
            zczb: true, // 注册资本
            gsgajg: true,
            YyqxDate: true,
            clrq: true // 成立日期
          }
          this.dwmcName = '单位名称:'
          this.jyfwName = '宗旨和业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.zczbName = '开办资金:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.gsgajgName = '登记管理机关:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:' //
          break
        case '党政机关':
          this.labelFlag = {
            dwmc: true, // 单位名称
            /* sjjyd: true, //实际经营地 */
            dwzs: true, // 单位住所
            YyqxDate: true, // 营业执照路径
            shtyxydm: true, // 社会统一信用代码
            gsgajg: true,
            dwzj: true // 单位座机
          }
          this.dwmcName = '单位名称:'
          /* this.sjjydName = "办公地址:"; // */
          this.dwzsName = '办公地址:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.YyqxDateName = '有效期:' //
          this.shtyxydmName = '证件编号:'
          this.gsgajgName = '行政区划:'
          break
        case '其他':
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            // dwlx: true, //单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true,
            zhxs: true
          }
          this.dwmcName = '字号名称:'
          this.shtyxydmName = '注册号:'
          // this.dwlxName = "单位类型:";
          this.dwzsName = '单位住所:' //
          this.frmcName = '经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '有效期限:' //
          this.gsgajgName = '行政区划:'
          break
        default:
          this.labelFlag = {
            shtyxydm: true, // 社会统一信用代码
            dwmc: true, // 单位名称
            dwzs: true, // 单位住所
            jyfw: true, // 经营范围
            YyqxDate: true, // 营业执照路径
            clrq: true, // 成立日期
            gsgajg: true,
            dwzj: true // 单位座机
          }
          this.shtyxydmName = '编号:'
          this.dwmcName = '单位名称:'
          this.dwzsName = '单位地址:' //
          this.jyfwName = '许可范围:' //
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.gsgajgName = '行政区划:'
          break
      }
    } /* 上一步 */,
    upstep() {
      this.$emit('nextstep', 1)
    },
    /* 下一步 */
    nextstep() {
      var flag1 = false
      var flag2 = false
      this.$refs['CommonForm1'].validate((valid) => {
        flag1 = valid
      })
      this.$refs['CommonForm2'].validate((valid) => {
        flag2 = valid
      })
      if (this.yyzzImg.havePic !== true) {
        this.$message({
          message: '请上传营业执照',
          type: 'warning'
        })
        flag2 = false
      }
      if (flag1 && flag2) {
        // 进行下一步
        saveQyrzxx(this.CommonForm, this.urlType)
          .then((e) => {
            this.$emit('nextstep', 3)
          })
          .catch((error) => {
            console.log(error.response.data.mesg)
            // this.$message.error(error.response.data.mesg)
          })
      }
    },
    removeCurImg() {
      this.yyzzImg.img = require('../../assets/img/yyzz.png')
      this.yyzzImg.closeBox = false
      this.CommonForm.yyzzUrl = ''
    },
    zczbChange(val) {
      this.djdwList.filter((item, index) => {
        if (item.value == val) {
          this.CommonForm.zczbDwLabel = item.label
        }
      })
    },
    /* 绑定事件 */
    gsgajgChange(value) {
      this.CommonForm.province = value[0]
      this.CommonForm.city = value[1]
      this.CommonForm.county = value[2]
    },
    /* 绑定事件 */
    handlePreview(file) {
      /* console.log(file); */
    },
    handleRemove(file, fileList) {
      this.yyzzImg.img = require('../../assets/img/yyzz.png')
    },
    beforeRemove(file, fileList) {},
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500kb!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    },
    onSuccess(response, file, fileList) {
      const data = response.data
      /*  //OCR识别
      if (data.oneData) {
        for (let key in data.oneData) {
          this.CommonForm[key] = data.oneData[key];
        }
        this.$message.success("证件上传成功!");
      } else {
        this.$message.warning("证件上传成功,但无法识别!请手动填写!");
      } */
      // 图片相关
      this.yyzzImg.img = this.returnShowPic + data.url
      this.CommonForm.yyzzUrl = data.url
      this.yyzzImg.loading = false
      this.yyzzImg.havePic = true
    },
    onProgress(event, file, fileList) {
      this.yyzzImg.loading = true
    },
    onError() {
      this.$message.error('证件上传失败!')
    },
    handleExceed(files, fileList) {}
  }
}
</script>
<style scoped lang='less'>
.body {
  margin: auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  ._title {
    width: 150px;
    margin-top: 50px;
    ._title_info {
      width: 150px;
      height: 30px;
      font-size: 25px;
      font-family: Helvetica;
      color: #333333;
      line-height: 30px;
    }
  }
  /* 单选组样式 */
  /deep/.el-radio__inner {
    border-radius: 0;
    border: none;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox_down.png");
    background-size: 100% 100%;
  }
  /deep/.el-radio__input .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox.png");
    background-size: 100% 100%;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    background: none;
  }
  ._yyzzPic {
    margin-top: 30px;
    position: relative;
    /deep/.el-upload-list {
      margin: 0;
      padding: 0;
      list-style: none;
      position: absolute;
      right: 0;
      top: -10px;
    }
    /deep/.deleteUpload {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 0;
      top: 15px;
      cursor: pointer;
      color: white;
    }
  }
  ._jbxxInfo {
    width: 1000px;
    ._jbxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._jbxxBd {
      margin: 30px 0px;
      ._jbxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .zczbItem {
          /deep/.el-select .el-input {
            width: 130px;
          }
        }
        .el-input {
          width: 297px;
        }
        /deep/.el-form-item__content {
          width: 297px;
        }
        /deep/.el-input--suffix {
          width: 297px;
        }
      }
    }
  }
  ._qtxxInfo {
    width: 1000px;
    ._qtxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._qtxxBd {
      margin: 30px 0px;
      ._qtxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .jydItem {
          /deep/.el-input {
            width: 860px;
          }
        }
        .el-input {
          width: 297px;
        }
        .el-textarea {
          width: 860px;
        }
        /deep/.el-input--suffix {
          width: 860px;
        }
      }
    }
  }
  ._buttonList {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 83px;
    button {
      width: 148px;
      height: 60px;
    }
    button:nth-child(2) {
      margin-left: 190px;
    }
  }
}
/deep/.el-input-group__append {
  background-color: #fff;
}
</style>
